export default "__VITE_ASSET__Bbsx2DXs__"